import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import DelegationService from '../../services/DelegationService';
import CriteriaDropdownComponent from '../../components/criteria/CriteriaDropdownComponent';
import CriteriaCalendarRangeComponent from '../../components/criteria/CriteriaCalendarRangeComponent';
import TemplateUtils from '../../utils/TemplateUtils';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import {DelegationStatus} from '../../model/enum/DelegationStatus';
import {Chip} from 'primereact/chip';
import {withRouter} from 'react-router-dom';

class DelegationListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new DelegationService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            types: [],
            statuses: [],
        };
    }
    renderCriteria() {
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='projectName-sc'
                    name='projectName'
                    colClass='col-lg-3 col-sm-6'
                    value={this.state.criteria.projectName}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    label={t('delegation.projectName')}
                    global={true}
                    timeoutHandler={this.refreshTable}
                    refreshFromBackend
                />
                <CriteriaDropdownComponent
                    id='status-sc'
                    name='status'
                    showClear
                    label={t('delegation.status')}
                    colClass='col-lg-3 col-sm-6'
                    value={this.state.criteria.status}
                    options={this.state.statuses}
                    placeholder='Wszystkie'
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    optionLabel='label'
                    refreshFromBackend
                />
                <CriteriaCalendarRangeComponent
                    id='date-sc'
                    idFrom='startDate-sc'
                    idTo='endDate-sc'
                    name='date'
                    nameFrom='startDate'
                    nameTo='endDate'
                    placeholderFrom='DD-MM-YYYY'
                    placeholderTo='DD-MM-YYYY'
                    colClass='col-xl-6 col-lg-12 col-sm-12'
                    from={this.state.criteria.startDate}
                    to={this.state.criteria.endDate}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    refreshFromBackend
                    showButtonBar
                    maxDateInfinite
                    labelFrom={'Data rozpoczęcia'}
                    labelTo={'Data zakończenia'}
                    inputsClassName='col-6'
                />
            </div>
        );
    }

    getDelegationStatuses() {
        this.enumService
            .getEnumList('DelegationStatus')
            .then((statuses) => {
                this.setState({
                    statuses,
                });
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy statusów');
            });
    }
    updateSearchCriteria(criteria) {
        let baseUpdateSearchCriteria = {
            status: criteria.status,
            projectName: criteria.projectName,
            startDate: criteria.startDate,
            endDate: criteria.endDate,
            firstResult: criteria.firstResult,
            maxResult: criteria.maxResult,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
        return baseUpdateSearchCriteria;
    }
    getCleanSearchCriteria() {
        let baseSearchCriteria = {
            status: undefined,
            projectName: undefined,
            firstResult: 0,
            maxResult: 10,
            sortField: 'id',
            sortAsc: true,
        };
        return baseSearchCriteria;
    }

    getActionTemplateOptions(rowData) {
        const {detailUrl} = this.props;
        const href = `${detailUrl}/${rowData?.id}`;
        const items = [];
        items.push({isDetailOption: true});
        if (
            this.authService.isUserInAnyRole(
                'ROLE_DELEGATION_SETTLEMENT_APPROVE',
                'ROLE_REPORT_OWN_DELEGATION',
                'ROLE_DELEGATION_EDIT',
                'ROLE_DELEGATION_VIEW'
            ) &&
            (rowData?.status?.enumValue === DelegationStatus.AWAITING_SETTLEMENT ||
                rowData?.status?.enumValue === DelegationStatus.SETTLEMENT_REJECTED ||
                rowData?.status?.enumValue === DelegationStatus.SETTLEMENT_ACCEPTED ||
                rowData?.status?.enumValue === DelegationStatus.SETTLEMENT_ENTERED)
        ) {
            items.push({
                label: 'Rozliczenia',
                icon: 'mdi mdi-cash',
                className: 'menu-item',
                command: () => {
                    this.navigationContext.addOrUpdateParam('settlement', true);
                    this.handleGoToDetail(href);
                },
            });
        }
        return items;
    }

    prepareColumns() {
        const result = [
            {field: 'delegated.fullName', header: t('delegation.delegated')},
            {field: 'delegator.fullName', header: t('delegation.delegator')},
            {field: 'project.name', header: t('delegation.project')},
            {field: 'startDate', header: t('delegation.details.startDate'), sortable: true},
            {field: 'endDate', header: t('delegation.details.endDate'), sortable: true},
            {
                field: 'status',
                header: t('delegation.status'),
                width: '190px',
                sortable: true,
                body: (rowData) => this.statusTemplate(rowData),
            },
            {field: 'destinations', header: t('delegation.destination'), body: this.destinationsTemplate},
        ];
        if (this.authService.isUserInAnyRole('ROLE_REPORT_OWN_DELEGATION', 'ROLE_DELEGATION_VIEW')) {
            result.push({
                key: 'actions',
                header: t('list.actions'),
                body: this.actionTemplate,
                className: 'table-column-action ',
            });
        }
        return result;
    }

    statusTemplate(item) {
        const color = DelegationStatus.getColor(item?.status?.enumValue);
        const label = TemplateUtils.enumTemplate('status', item);
        return <Chip label={label} style={{background: color, color: 'white', fontWeight: '900px'}} />;
    }

    destinationsTemplate = (rowData) => {
        if (Array.isArray(rowData.destinations)) {
            const destiantion = rowData.destinations.join(', ');
            return destiantion;
        }
    };
    getProjectList(query) {
        const {categories, status} = this.state.criteria;
        const {projectsAfterDate} = this.props;

        const date = projectsAfterDate ? projectsAfterDate : new Date();

        this.service
            .search(query, 'ACTIVE', categories, status?.code === 'NO_LEADER', date)
            .then((projects) => {
                this.setState({projects});
            })
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy dostępnych projektów');
            });
    }
    initializeFromBackend() {
        this.getDelegationStatuses();
    }

    prepareHeaderItems() {
        return this.authService.isUserInAnyRole('ROLE_REPORT_OWN_DELEGATION', 'ROLE_DELEGATION_EDIT')
            ? [
                  {
                      id: 'newDelegationButton',
                      label: t('Dodaj wniosek'),
                      type: 'BUTTON',
                      className: 'float-right',
                      variant: 'blue',
                      iconName: '',
                      iconSide: 'left',
                      iconColor: 'white',
                      onClick: this.handleGoToNew,
                  },
              ]
            : [];
    }
    handleOpenNewDialog(e) {
        let basicElement = this.initNewElement();
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: true, element: basicElement, dialogViewMode: 'NEW'});
    }

    render() {
        return <div className='container-fluid'>{this.renderView()}</div>;
    }
}

DelegationListContainer.defaultProps = {
    detailUrl: '/#/delegation/details',
    newUrl: '/#/delegation/create',
    lazy: true,
};

DelegationListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
    lazy: PropTypes.bool,
};

export default withRouter(DelegationListContainer);
